export const NotFound = () => {
  return <div style={{color:'red'}}><h1>Not Found</h1></div>;
};
